import React, { useEffect } from 'react';
import { FormViewContent } from 'components/FormViewContent';
import _ from 'lodash';
import { Grid } from '@material-ui/core';
import {
  createLoadingSelector,
  createErrorMessageSelector,
  ProtocolNumSelector,
  ProtocolIdSelector,
  lSelectorGetProtDetails,
  eSelectorGetProtDetails
} from 'selectors';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { RenderControl } from 'components/RenderHelpers';
import molecules from 'ctsutheme/components/molecules';
import atoms from 'ctsutheme/components/atoms';
import {
  getProtocolIntegrations,
  getProtocolstartInfo,
  PRT_INTEGRATIONS_ACTIONS
} from 'actions/protocols/integrations';
import { withAppContext } from '@ctsu/loader';
import { getOpenSetup, OPEN_SETUP_ACTIONS } from 'actions/protocols/opensetup';
import { bindLogger } from 'helpers/BindLogger';
import {
  CanUserAccessIntegrations,
  CanUserAccessIntegrationTask,
  CanUserAccessIntegrationStart
} from 'appconstants/Permission';
import PropTypes from 'prop-types';
import { BoolToString } from 'components';
import { getPsrs } from 'actions/protocols/psrs';
import {
  TaskAccess,
  STARTIntegration,
  IntegrationSummary,
  DTLInfo
} from './components';

const loadingIntSelector = createLoadingSelector([
  PRT_INTEGRATIONS_ACTIONS.GET_PROT_INTEGRATIONS
]);
const errorIntSelector = createErrorMessageSelector([
  PRT_INTEGRATIONS_ACTIONS.GET_PROT_INTEGRATIONS
]);

const loadingStartSelector = createLoadingSelector([
  PRT_INTEGRATIONS_ACTIONS.GET_PROT_START_INFO
]);
const errorStartSelector = createErrorMessageSelector([
  PRT_INTEGRATIONS_ACTIONS.GET_PROT_START_INFO
]);

const loadingOPENTaskselector = createLoadingSelector([
  OPEN_SETUP_ACTIONS.GET_OPENSETUP
]);
const errorOPENTaskSelector = createErrorMessageSelector([
  OPEN_SETUP_ACTIONS.GET_OPENSETUP
]);


const { List } = molecules;
const { Divider } = atoms;

const Integrations = props => {
  const {
    protocolId,
    protocolNumber,
    context,
    onGetOpenSetupData,
    onGetProtocolIntegrations,
    onGetProtocolstartInfo,
    openSetupInfo,
    integrationInfo,
    startInfo,
    isloadingIntSelector,
    iserrorIntSelector,
    isloadingOPENTaskselector,
    iserrorOPENTaskSelector,
    isloadingStartSelector,
    iserrorStartSelector,
    isLoadingPrtDetails,
    iserrorPrtDetails,
    onGetPsr
  } = props;

  const {
    isCirbRequired,
    isDtlRqd,
    dtlTemplate
  } = startInfo || {};


  useEffect(() => {
    if (!_.isEmpty(protocolNumber)) {
      bindLogger(onGetPsr, context)(protocolNumber);
      bindLogger(onGetProtocolIntegrations, context)(protocolNumber);
      bindLogger(onGetProtocolstartInfo, context)(protocolNumber);
      bindLogger(onGetOpenSetupData, context)(protocolNumber);
    }
  }, [protocolNumber, onGetProtocolIntegrations,
    onGetProtocolstartInfo, onGetOpenSetupData, onGetPsr, context]);
  return (
    <RenderControl
      isLoading={isLoadingPrtDetails}
      iserror={iserrorPrtDetails}
      compName="Integration Information"
      permission={CanUserAccessIntegrations()}
    >

      <Grid container justify="center" spacing={4}>
        <Grid item xs>
          <RenderControl
            isLoading={isloadingIntSelector}
            iserror={iserrorIntSelector}
            compName="Integration Information"
            permission
          >
            <IntegrationSummary
              intInfo={integrationInfo}
              selectedProt={protocolId}
            />
          </RenderControl>
        </Grid>
        <Grid item xs>
          <div> {/* <div className="vertical-divider-left"> */}
            <List>
              <RenderControl
                isLoading={isloadingStartSelector}
                iserror={iserrorStartSelector}
                compName="START Information"
                permission={CanUserAccessIntegrationStart()}
              >
                <STARTIntegration startInfo={startInfo} />
              </RenderControl>
              <Divider />
              <RenderControl
                isLoading={isloadingOPENTaskselector}
                iserror={iserrorOPENTaskSelector}
                compName="Task Access"
                permission={CanUserAccessIntegrationTask()}
              >
                <div style={{ margin: '1rem 0' }}>
                  <TaskAccess taskAccessData={openSetupInfo.protTaskRegtypesAccesses || []} />
                </div>
              </RenderControl>
              <RenderControl
                isLoading={isloadingIntSelector}
                iserror={iserrorIntSelector}
                compName="Integration Information"
                permission
              >
                <FormViewContent
                  primaryText="Rave Study?"
                  name="isRaveStudy"
                  secondaryText={
                    <BoolToString boolValue={integrationInfo && integrationInfo.isRaveStudy} />
}
                />
                <Divider />
                <FormViewContent
                  primaryText="CIRB Documents Posted?"
                  name="cribPostingFlag"
                  secondaryText={
                    <BoolToString boolValue={integrationInfo && integrationInfo.isCirbPosting} />
                }
                />
                <Divider />
                <FormViewContent
                  primaryText="Financial Documents Posted?"
                  name="financialDoc"
                  secondaryText={
                    <BoolToString boolValue={integrationInfo && integrationInfo.financialDoc} />
                }
                />
                <FormViewContent
                  primaryText="CIRB Reviewed?"
                  name="isCirbRequired"
                  secondaryText={<BoolToString boolValue={isCirbRequired} />}
                />
                <Divider />
                <DTLInfo isDtlRqd={isDtlRqd} dtlTemplate={dtlTemplate} />
                <Divider />
                <FormViewContent
                  primaryText="Has Screening Component?"
                  name="isHasScreeningComp"
                  secondaryText={<BoolToString boolValue={integrationInfo.isHasScreeningComp} />}
                />
                <Divider />
                <FormViewContent
                  primaryText="OPEN to Submit CDUS?"
                  name="isOpenCdusSubmission"
                  secondaryText={(
                    <BoolToString boolValue={openSetupInfo && openSetupInfo.openConfig
                      && openSetupInfo.openConfig.isOpenCdusSubmission}
                    />
)}
                />
                
                <Divider />
                <FormViewContent
                  primaryText="Non-IND/Non-Treatment Investigator Allowed?"
                  name="isNonIndNonTreat"
                  secondaryText={<BoolToString boolValue={integrationInfo.isNonIndNonTreat} />}
                />
              </RenderControl>
            </List>
          </div>
        </Grid>
      </Grid>
    </RenderControl>
  );
};

Integrations.propTypes = {
  protocolId: PropTypes.number.isRequired,
  protocolNumber: PropTypes.string.isRequired,
  context: PropTypes.oneOfType([PropTypes.object]),
  onGetOpenSetupData: PropTypes.func,
  onGetProtocolIntegrations: PropTypes.func,
  onGetPsr: PropTypes.func,
  onGetProtocolstartInfo: PropTypes.func,
  openSetupInfo: PropTypes.oneOfType([PropTypes.object]),
  integrationInfo: PropTypes.oneOfType([PropTypes.object]),
  startInfo: PropTypes.oneOfType([PropTypes.object])
};

Integrations.defaultProps = {
  context: null,
  onGetOpenSetupData: null,
  onGetProtocolIntegrations: null,
  onGetPsr: null,
  onGetProtocolstartInfo: null,
  openSetupInfo: null,
  integrationInfo: null,
  startInfo: null
};

const withConnectState = connect(
  (state, ownProps) => ({
    protocolNumber: ProtocolNumSelector(state),
    protocolId: ProtocolIdSelector(state),
    openSetupInfo: state.openData.openData,
    integrationInfo: state.integrations.integrationInfo,
    startInfo: state.integrations.startInfo,
    isloadingIntSelector: loadingIntSelector(state),
    iserrorIntSelector: errorIntSelector(state),
    isloadingOPENTaskselector: loadingOPENTaskselector(state),
    iserrorOPENTaskSelector: errorOPENTaskSelector(state),
    isloadingStartSelector: loadingStartSelector(state),
    iserrorStartSelector: errorStartSelector(state),
    isLoadingPrtDetails: lSelectorGetProtDetails(state),
    iserrorPrtDetails: eSelectorGetProtDetails(state)
  }),
  dispatch => bindActionCreators(
    {
      onGetPsr: getPsrs,
      onGetOpenSetupData: getOpenSetup,
      onGetProtocolIntegrations: getProtocolIntegrations,
      onGetProtocolstartInfo: getProtocolstartInfo
    },
    dispatch
  )
);

const IntegrationsContainer = compose(
  withConnectState,
  withAppContext
)(Integrations);

export default IntegrationsContainer;
